// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Space+Grotesk:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f8fafc;
  color: #1e293b;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Space Grotesk', sans-serif;
}

.App {
  min-height: 100vh;
}

/* Auth Pages Shared Styles */
.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  position: relative;
  overflow: hidden;
}

.auth-container::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(56, 189, 248, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.auth-container::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(147, 197, 253, 0.2) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.auth-card {
  background: white;
  padding: 3rem;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  max-width: 480px;
  width: 100%;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
}

.auth-logo {
  text-align: center;
  margin-bottom: 2rem;
}

.auth-logo h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #0ea5e9;
  margin-bottom: 0.5rem;
}

.auth-logo p {
  color: #64748b;
  font-size: 0.95rem;
}

/* Dashboard Layout */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  background: #f8fafc;
}

.sidebar {
  width: 280px;
  background: white;
  border-right: 1px solid #e2e8f0;
  padding: 2rem 0;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 100;
  overflow-y: auto;
}

.sidebar-logo {
  padding: 0 2rem;
  margin-bottom: 2.5rem;
}

.sidebar-logo h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0ea5e9;
}

.sidebar-nav {
  list-style: none;
  padding: 0;
}

.sidebar-nav-item {
  margin: 0.25rem 1rem;
}

.sidebar-nav-link {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  color: #64748b;
  text-decoration: none;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.95rem;
}

.sidebar-nav-link:hover {
  background: #f1f5f9;
  color: #0ea5e9;
}

.sidebar-nav-link.active {
  background: #e0f2fe;
  color: #0ea5e9;
}

.sidebar-user {
  margin-top: auto;
  padding: 1.5rem 2rem;
  border-top: 1px solid #e2e8f0;
}

.main-content {
  margin-left: 280px;
  flex: 1 1;
  padding: 2rem;
}

.page-header {
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 0.5rem;
}

.page-header p {
  color: #64748b;
  font-size: 1rem;
}

/* Calendar Grid */
.calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
}

.calendar-card {
  background: white;
  padding: 1.5rem;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
}

.calendar-card:hover {
  border-color: #0ea5e9;
  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.12);
}

/* Event List */
.event-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.event-card {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  border-left: 4px solid #0ea5e9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.event-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-aguardando {
  background: #fef3c7;
  color: #92400e;
}

.status-em-progresso {
  background: #dbeafe;
  color: #1e40af;
}

.status-finalizado {
  background: #d1fae5;
  color: #065f46;
}

/* Buttons */
button {
  font-family: 'Manrope', sans-serif;
}

.btn-primary {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.95rem;
}


/* ============================================ */
/* RESPONSIVIDADE MOBILE */
/* ============================================ */

@media (max-width: 768px) {
  /* Auth pages mobile */
  .auth-container {
    padding: 1rem;
  }

  .auth-card {
    width: 100% !important;
    max-width: 100% !important;
    padding: 1.5rem !important;
    margin: 0 !important;
  }

  /* Page header mobile */
  .page-header {
    padding: 1rem !important;
    flex-direction: column !important;
    gap: 1rem !important;
  }

  .page-header h1 {
    font-size: 1.75rem !important;
  }

  /* Dialog/Modal mobile */
  .dialog-mobile-responsive {
    width: 95vw !important;
    max-width: 95vw !important;
    max-height: 85vh !important;
    margin: 0 !important;
    padding: 0.75rem !important;
    display: flex !important;
    flex-direction: column !important;
  }

  /* Forms mobile */
  .dialog-mobile-responsive form {
    max-height: calc(85vh - 100px) !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding-right: 0.5rem !important;
    flex: 1 1 !important;
  }
  
  /* Garantir que inputs sejam visíveis */
  .dialog-mobile-responsive input,
  .dialog-mobile-responsive textarea,
  .dialog-mobile-responsive select {
    font-size: 16px !important;
    width: 100% !important;
  }
  
  /* Grid de duas colunas vira uma coluna no mobile */
  .dialog-mobile-responsive form > div[style*="gridTemplateColumns"] {
    grid-template-columns: 1fr !important;
  }

  /* Event cards mobile */
  .event-card {
    padding: 1rem !important;
  }

  .event-card h3 {
    font-size: 1rem !important;
  }

  /* Button groups mobile */
  .event-card > div:first-child {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 0.75rem !important;
  }

  .event-card .status-badge {
    align-self: flex-start;
  }

  /* Calendar view mobile */
  .calendar-view-controls {
    flex-direction: column !important;
    gap: 1rem !important;
  }

  /* Grid layouts to single column */
  [style*="display: grid"][style*="gridTemplateColumns"] {
    grid-template-columns: 1fr !important;
  }

  /* Two column forms to single */
  [style*="gridTemplateColumns: '1fr 1fr'"] {
    grid-template-columns: 1fr !important;
  }

  /* Layout adjustments */
  .layout-sidebar {
    position: fixed !important;
    left: -100% !important;
    transition: left 0.3s ease !important;
    z-index: 1000 !important;
  }

  .layout-sidebar.open {
    left: 0 !important;
  }
}

@media (max-width: 480px) {
  /* Extra small screens */
  .auth-card {
    padding: 1rem !important;
  }

  .page-header h1 {
    font-size: 1.5rem !important;
  }

  .page-header p {
    font-size: 0.85rem !important;
  }

  button {
    min-height: 44px !important;
    font-size: 0.9rem !important;
  }

  input, select, textarea {
    font-size: 16px !important; /* Previne zoom no iOS */
  }
}

.btn-primary:hover {
  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);
}

/* Form Inputs */
input, textarea, select {
  font-family: 'Manrope', sans-serif;
}

/* Responsive */
@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    position: relative;
    height: auto;
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .calendar-grid {
    grid-template-columns: 1fr;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iFAAiF;EACjF,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,aAAa;EACb,OAAO;EACP,MAAM;EACN,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kCAAkC;AACpC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;;AAGA,iDAAiD;AACjD,0BAA0B;AAC1B,iDAAiD;;AAEjD;EACE,sBAAsB;EACtB;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA,uBAAuB;EACvB;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,wBAAwB;EACxB;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,oBAAoB;IACpB,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;EACnC;;EAEA,iBAAiB;EACjB;IACE,yCAAyC;IACzC,2BAA2B;IAC3B,6BAA6B;IAC7B,gCAAgC;IAChC,oBAAkB;EACpB;;EAEA,uCAAuC;EACvC;;;IAGE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,mDAAmD;EACnD;IACE,qCAAqC;EACvC;;EAEA,uBAAuB;EACvB;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,yBAAyB;EACzB;IACE,iCAAiC;IACjC,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,iCAAiC;IACjC,oBAAoB;EACtB;;EAEA,kCAAkC;EAClC;IACE,qCAAqC;EACvC;;EAEA,+BAA+B;EAC/B;IACE,qCAAqC;EACvC;;EAEA,uBAAuB;EACvB;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,qCAAqC;IACrC,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,wBAAwB;EACxB;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B,EAAE,wBAAwB;EACtD;AACF;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Space+Grotesk:wght@400;500;600;700&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #f8fafc;\n  color: #1e293b;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Space Grotesk', sans-serif;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Auth Pages Shared Styles */\n.auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.auth-container::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(56, 189, 248, 0.15) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.auth-container::after {\n  content: '';\n  position: absolute;\n  bottom: -30%;\n  left: -10%;\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(147, 197, 253, 0.2) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.auth-card {\n  background: white;\n  padding: 3rem;\n  border-radius: 24px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);\n  max-width: 480px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n  backdrop-filter: blur(10px);\n}\n\n.auth-logo {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.auth-logo h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #0ea5e9;\n  margin-bottom: 0.5rem;\n}\n\n.auth-logo p {\n  color: #64748b;\n  font-size: 0.95rem;\n}\n\n/* Dashboard Layout */\n.dashboard-layout {\n  display: flex;\n  min-height: 100vh;\n  background: #f8fafc;\n}\n\n.sidebar {\n  width: 280px;\n  background: white;\n  border-right: 1px solid #e2e8f0;\n  padding: 2rem 0;\n  position: fixed;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  z-index: 100;\n  overflow-y: auto;\n}\n\n.sidebar-logo {\n  padding: 0 2rem;\n  margin-bottom: 2.5rem;\n}\n\n.sidebar-logo h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0ea5e9;\n}\n\n.sidebar-nav {\n  list-style: none;\n  padding: 0;\n}\n\n.sidebar-nav-item {\n  margin: 0.25rem 1rem;\n}\n\n.sidebar-nav-link {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.875rem 1rem;\n  color: #64748b;\n  text-decoration: none;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 0.95rem;\n}\n\n.sidebar-nav-link:hover {\n  background: #f1f5f9;\n  color: #0ea5e9;\n}\n\n.sidebar-nav-link.active {\n  background: #e0f2fe;\n  color: #0ea5e9;\n}\n\n.sidebar-user {\n  margin-top: auto;\n  padding: 1.5rem 2rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.main-content {\n  margin-left: 280px;\n  flex: 1;\n  padding: 2rem;\n}\n\n.page-header {\n  margin-bottom: 2rem;\n}\n\n.page-header h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 0.5rem;\n}\n\n.page-header p {\n  color: #64748b;\n  font-size: 1rem;\n}\n\n/* Calendar Grid */\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1.5rem;\n}\n\n.calendar-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n}\n\n.calendar-card:hover {\n  border-color: #0ea5e9;\n  box-shadow: 0 8px 24px rgba(14, 165, 233, 0.12);\n}\n\n/* Event List */\n.event-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.event-card {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 12px;\n  border-left: 4px solid #0ea5e9;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.event-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n/* Status Badges */\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-aguardando {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-em-progresso {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.status-finalizado {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n/* Buttons */\nbutton {\n  font-family: 'Manrope', sans-serif;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.95rem;\n}\n\n\n/* ============================================ */\n/* RESPONSIVIDADE MOBILE */\n/* ============================================ */\n\n@media (max-width: 768px) {\n  /* Auth pages mobile */\n  .auth-container {\n    padding: 1rem;\n  }\n\n  .auth-card {\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 1.5rem !important;\n    margin: 0 !important;\n  }\n\n  /* Page header mobile */\n  .page-header {\n    padding: 1rem !important;\n    flex-direction: column !important;\n    gap: 1rem !important;\n  }\n\n  .page-header h1 {\n    font-size: 1.75rem !important;\n  }\n\n  /* Dialog/Modal mobile */\n  .dialog-mobile-responsive {\n    width: 95vw !important;\n    max-width: 95vw !important;\n    max-height: 85vh !important;\n    margin: 0 !important;\n    padding: 0.75rem !important;\n    display: flex !important;\n    flex-direction: column !important;\n  }\n\n  /* Forms mobile */\n  .dialog-mobile-responsive form {\n    max-height: calc(85vh - 100px) !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    padding-right: 0.5rem !important;\n    flex: 1 !important;\n  }\n  \n  /* Garantir que inputs sejam visíveis */\n  .dialog-mobile-responsive input,\n  .dialog-mobile-responsive textarea,\n  .dialog-mobile-responsive select {\n    font-size: 16px !important;\n    width: 100% !important;\n  }\n  \n  /* Grid de duas colunas vira uma coluna no mobile */\n  .dialog-mobile-responsive form > div[style*=\"gridTemplateColumns\"] {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Event cards mobile */\n  .event-card {\n    padding: 1rem !important;\n  }\n\n  .event-card h3 {\n    font-size: 1rem !important;\n  }\n\n  /* Button groups mobile */\n  .event-card > div:first-child {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 0.75rem !important;\n  }\n\n  .event-card .status-badge {\n    align-self: flex-start;\n  }\n\n  /* Calendar view mobile */\n  .calendar-view-controls {\n    flex-direction: column !important;\n    gap: 1rem !important;\n  }\n\n  /* Grid layouts to single column */\n  [style*=\"display: grid\"][style*=\"gridTemplateColumns\"] {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Two column forms to single */\n  [style*=\"gridTemplateColumns: '1fr 1fr'\"] {\n    grid-template-columns: 1fr !important;\n  }\n\n  /* Layout adjustments */\n  .layout-sidebar {\n    position: fixed !important;\n    left: -100% !important;\n    transition: left 0.3s ease !important;\n    z-index: 1000 !important;\n  }\n\n  .layout-sidebar.open {\n    left: 0 !important;\n  }\n}\n\n@media (max-width: 480px) {\n  /* Extra small screens */\n  .auth-card {\n    padding: 1rem !important;\n  }\n\n  .page-header h1 {\n    font-size: 1.5rem !important;\n  }\n\n  .page-header p {\n    font-size: 0.85rem !important;\n  }\n\n  button {\n    min-height: 44px !important;\n    font-size: 0.9rem !important;\n  }\n\n  input, select, textarea {\n    font-size: 16px !important; /* Previne zoom no iOS */\n  }\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #0284c7 0%, #0369a1 100%);\n  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3);\n}\n\n/* Form Inputs */\ninput, textarea, select {\n  font-family: 'Manrope', sans-serif;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .sidebar {\n    width: 100%;\n    position: relative;\n    height: auto;\n  }\n  \n  .main-content {\n    margin-left: 0;\n  }\n  \n  .calendar-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
